<template>
  <div class="home">
    <main>
      <Header />

      <Banner />

      <Main>
        <template #cards>
          <Loader v-if="loading" />
          <div class="cards__volunteer volunteer" v-else>
            <PostVolunteers />
          </div>
        </template>
      </Main>
    </main>
    <Footer />
    <VolunteersForm />
    <Languages :locales="locales" />
  </div>
</template>

<script>
import { Banner, Main } from "@/components";
import { AuxiliaryHeader as Header } from "@/components/app/Headers";

export default {
  name: "Volunteers",
  data: () => ({
    loading: true,
    locales: [
      { locale: "kk" },
      { locale: "ru" },
      { locale: "en" },
      { locale: "uz" },
      { locale: "ky" },
      { locale: "ne" },
      { locale: "fl" },
      { locale: "ka" },
      { locale: "zu" },
      { locale: "af" },
      { locale: "yo" },
      { locale: "ig" }
    ]
  }),
  mounted() {
    this.loading = false;
  },
  components: {
    Header,
    Banner,
    Main,
    PostVolunteers: () => import("@/components/app/Posts/PostVolunteer"),
    VolunteersForm: () => import("@/components/app/Forms/Volunteers"),
    Languages: () => import(`@/components/app/Languages.vue`)
  }
};
</script>
